import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import PropTypes from 'prop-types'
import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { SelectNew } from 'src/editor/shared/ui-lib/select-new/select-new'
import MobileIconUi from '../styles/ui/MobileIconUi'

function ShadowStyle({
  shadow = 'none',
  mobileShadow,
  isTitleNeeded = true,
  labelText = '',
  update,
  mobileUpdate,
  withoutHorizontalLine = false,
}) {
  const { isMobile } = useDeviceModeContext()
  const { t } = useTranslation()
  const boxShadowOptions = [
    { label: t('settings_styles.shadow.now_shadow'), value: 'none' },
    {
      label: t('settings_styles.shadow.soft_shadow'),
      value: '0px 1px 5px 0px rgba(0, 0, 0, 0.2)',
    },
    {
      label: t('settings_styles.shadow.mid_shadow'),
      value: '0 1px 5px rgba(0, 0, 0, 0.4)',
    },
    {
      label: t('settings_styles.shadow.hard_shadow'),
      value: '0 1px 5px rgba(0, 0, 0, 0.7)',
    },
    {
      label: t('settings_styles.shadow.far_shadow'),
      value: '0 8px 1px rgba(0, 0, 0, 0.1)',
    },
    {
      label: t('settings_styles.shadow.blurry_shadow'),
      value:
        '0 0 25px rgba(0, 0, 0, 0.2), 0 0 15px rgba(0, 0, 0, 0.2), 0 0 3px rgba(0, 0, 0, 0.4)',
    },
    {
      label: t('settings_styles.shadow.dark_with_highlight'),
      value:
        '0 0 25px rgba(0, 0, 0, 0.4), 0 0 15px rgba(255, 255, 255, 0.2), 0 0 3px rgba(255, 255, 255, 0.4)',
    },
    {
      label: t('settings_styles.shadow.soft_inner_shadow'),
      value: 'inset 0 1px 5px rgba(0, 0, 0, 0.2)',
    },
    {
      label: t('settings_styles.shadow.mid_inner_shadow'),
      value: 'inset 0 1px 5px rgba(0, 0, 0, 0.4)',
    },
    {
      label: t('settings_styles.shadow.hard_inner_shadow'),
      value: 'inset 0 1px 5px rgba(0, 0, 0, 0.7)',
    },
  ]
  const getShadowValue = () => {
    const calculatedShadow = isMobile ? mobileShadow || shadow : shadow
    return boxShadowOptions.find(
      boxShadowKey => boxShadowKey.value === calculatedShadow,
    )
  }

  const updateProp = boxShadowOption => {
    const value = boxShadowOption.value
    return isMobile ? mobileUpdate(value) : update(value)
  }

  return (
    <React.Fragment>
      {isTitleNeeded && (
        <GroupTitle
          afterChildren={isMobile && <MobileIconUi />}
          withoutHorizontalLine={withoutHorizontalLine}
        >
          settings_styles.shadow.label
        </GroupTitle>
      )}
      <SelectNew
        dataTestElement="shadow-style-select"
        selectedOption={getShadowValue()}
        onChange={updateProp}
        options={boxShadowOptions}
        labelText={labelText}
      />
    </React.Fragment>
  )
}

ShadowStyle.propTypes = {
  update: PropTypes.func.isRequired,
  mobileUpdate: PropTypes.func.isRequired,
  shadow: PropTypes.string,
  mobileShadow: PropTypes.string,
  isTitleNeeded: PropTypes.bool,
  withoutHorizontalLine: PropTypes.bool,
  labelText: PropTypes.string,
}

export default memo(ShadowStyle)
